var staticWindow = require('./staticWindow')

/**
  * 判断是否Window对象
  *
  * @param {Object} obj 对象
  * @return {Boolean}
  */
function isWindow (obj) {
  return staticWindow && !!(obj && obj === obj.window)
}

module.exports = isWindow



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/isWindow.js
// module id = sMss
// module chunks = 137